export type ShellPreferenceKey = "locale" | "theme";

export interface ShellPreferenceCache {
  read(key: ShellPreferenceKey): string | undefined;
  write(key: ShellPreferenceKey, value: string): void;
}

const prefix = "thw.shell.";

/** Only non-sensitive locale and theme codes may be stored here. */
export const browserShellPreferenceCache: ShellPreferenceCache = {
  read(key) {
    try {
      return window.localStorage.getItem(`${prefix}${key}`) ?? undefined;
    } catch {
      return undefined;
    }
  },
  write(key, value) {
    try {
      window.localStorage.setItem(`${prefix}${key}`, value);
    } catch {
      // The current session remains usable when browser storage is unavailable.
    }
  },
};
